
import { Component } from 'nuxt-property-decorator'
import { FSXABaseSection } from 'fsxa-pattern-library'

@Component({
  name: 'StFontSizes',
  components: {
    FontSizesOverview: () => import('../../overview/FontSizesOverview.vue'),
  },
})
export default class StFontSizes extends FSXABaseSection {
}
